import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/components/template/header/header.service';

@Component({
  selector: 'eM-brand-crud',
  templateUrl: './brand-crud.component.html',
  styleUrls: ['./brand-crud.component.css']
})
export class BrandCrudComponent implements OnInit {

  constructor(private router: Router, private headerService: HeaderService) {
    this.headerService.headerData = {
      title: 'Gestao de Produto -> Marca',
      icon: 'branding_watermark',
      routeUrl: '/brands'
    }
  }

  ngOnInit(): void {
  }


  navigateProductCreate(): void {
    this.router.navigate(['/brands/create'])
  }


}
